import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

const FooterContainer = styled.footer`
  background: ${props => props.theme.background};
  border-top: 1px solid ${props => props.theme.border};
  padding: 1rem;
  margin-top: 1rem;
`;

const FooterContent = styled.div`
  padding-top: 0.25rem;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
`;

const FooterText = styled.div`
  color: ${props => props.theme.textMuted};
  font-size: 0.8rem;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const FooterLink = styled.a`
  background: none;
  border: none;
  color: ${props => props.theme.textMuted};
  font-size: 0.8rem;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #5865f2;
  }
`;

const RegisterAccountFooter = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  const openPrivacyPolicy = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsPrivacyModalOpen(true);
  };

  const openTermsOfService = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsTermsModalOpen(true);
  };

  return (
    <FooterContainer>
      <FooterText>
        © 2023 PlanMySemester. All rights reserved.
      </FooterText>
      <FooterContent>
        <FooterLinks>
          <FooterLink href="https://buymeacoffee.com/tylerthedev" target="_blank" rel="noopener noreferrer">
            Donate
          </FooterLink>
          <FooterLink href="#privacy-policy" onClick={openPrivacyPolicy}>
            Privacy Policy
          </FooterLink>
          <FooterLink href="#terms-of-service" onClick={openTermsOfService}>
            Terms of Service
          </FooterLink>
        </FooterLinks>
      </FooterContent>

      <Modal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
        title="Privacy Policy"
      >
        <PrivacyPolicy />
      </Modal>

      <Modal
        isOpen={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
        title="Terms of Service"
      >
        <TermsOfService />
      </Modal>
    </FooterContainer>
  );
};

export default RegisterAccountFooter;
